/**
 * @generated SignedSource<<08db8f1f7e3ac17ddadc66960b3578c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorProjectContent_searchResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PhotoLikesLoader_searchResult" | "ProjectCoverPhotoContainer_searchResult" | "ProjectOverviewContainer_searchResult" | "ProjectPhotosGrid_searchResult" | "ProjectViewMoreContainer_searchResult">;
  readonly " $fragmentType": "InteriorProjectContent_searchResult";
};
export type InteriorProjectContent_searchResult$key = {
  readonly " $data"?: InteriorProjectContent_searchResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorProjectContent_searchResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorProjectContent_searchResult",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotoLikesLoader_searchResult"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectCoverPhotoContainer_searchResult"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectOverviewContainer_searchResult"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectPhotosGrid_searchResult"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectViewMoreContainer_searchResult"
    }
  ],
  "type": "TradeInteriorProjectQueryOutput",
  "abstractKey": null
};

(node as any).hash = "c393addf660ab9b5e6e02f7e0c0a96ca";

export default node;
